// Mirror of Postgres enums in ops.* schema

export const USER_ROLES = ['super_admin', 'branch_admin'] as const;
export type UserRole = (typeof USER_ROLES)[number];

export const SUPPLY_TYPES = ['stock', 'production'] as const;
export type SupplyType = (typeof SUPPLY_TYPES)[number];

export const SUPPLIER_TIERS = ['fast', 'normal', 'unreliable'] as const;
export type SupplierTier = (typeof SUPPLIER_TIERS)[number];

export const PO_STATUSES = [
  'suggested',
  'approved',
  'ordered',
  'received',
  'cancelled',
] as const;
export type PoStatus = (typeof PO_STATUSES)[number];

export const TRANSFER_STATUSES = [
  'suggested',
  'approved',
  'in_transit',
  'received',
  'cancelled',
] as const;
export type TransferStatus = (typeof TRANSFER_STATUSES)[number];

export const SUGGEST_ACTIONS = [
  'transfer',
  'purchase',
  'split',
  'urgent_transfer',
  'watch',
  'skip',
] as const;
export type SuggestAction = (typeof SUGGEST_ACTIONS)[number];

export const REQUEST_KINDS = [
  'transfer_request',
  'purchase_request',
  'stock_adjust',
  'target_change',
  'demand_request',
] as const;
export type RequestKind = (typeof REQUEST_KINDS)[number];

export const REQUEST_STATUSES = [
  'submitted',
  'under_review',
  'approved',
  'rejected',
  'fulfilled',
  'cancelled',
] as const;
export type RequestStatus = (typeof REQUEST_STATUSES)[number];

export const URGENCY_LEVELS = ['low', 'normal', 'urgent'] as const;
export type Urgency = (typeof URGENCY_LEVELS)[number];
